export type SellerNotificationType =
  | 'order'
  | 'bid'
  | 'offer'
  | 'payment'
  | 'product'
  | 'account'
  | 'promotional'
  | 'message'
  | 'system';

export interface SellerNotification {
  _id: string;
  id?: string;
  type: SellerNotificationType | string;
  target?: 'buyer' | 'seller' | 'both';
  title: string;
  message: string;
  body?: string;
  payload?: Record<string, unknown>;
  data?: Record<string, unknown>;
  link?: string;
  actionUrl?: string;
  conversationId?: string;
  isRead: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface NotificationPayload {
  type?: string;
  conversationId?: string;
  conversation?: string | { id?: string; _id?: string };
  productId?: string;
  [key: string]: unknown;
}

export function getNotificationPayload(
  notification: SellerNotification
): NotificationPayload {
  return (notification.payload || notification.data || {}) as NotificationPayload;
}

export function isSellerRelevantNotification(notification: { type?: string; target?: string }): boolean {
  // If target is set, use it as the authoritative filter
  if (notification.target) {
    return notification.target === 'seller' || notification.target === 'both';
  }
  // Fallback for legacy notifications without a target field
  const type = notification.type || '';
  return (
    type === 'order' ||
    type === 'bid' ||
    type === 'offer' ||
    type === 'payment' ||
    type === 'message'
  );
}

export function getNotificationId(notification: { _id?: string; id?: string }): string {
  return notification._id || notification.id || '';
}
